









import Vue from "vue";
import Component from "vue-class-component";
import { mask } from 'vue-the-mask';

@Component({
    directives: {
        mask,
    }
})
export default class DadosValidade extends Vue {

    public valMask = '##-####';

}
